/* new-pdp-nord-hero.js
   Purchase module for the Nord PDP hero (variant/colour selection, pricing, cart,
   gallery, video pop-up, accessories). Moved out of the section file verbatim on
   2026-08-18 to pull sections/new-pdp-nord-hero.liquid back from the 256 KB
   write-time limit; the only edits are the three section-id lookups, which now
   take the id as an argument. One init per hero instance, keyed by the id the
   section prints on its <section> and its two JSON blobs. Re-inits on
   shopify:section:load so the theme editor keeps working after a re-render. */
(function () {
  function init(sid) {
  var root = document.getElementById('npwmp-hero-' + sid);
  if (!root || root.dataset.npwmpInit === '1') return;
  root.dataset.npwmpInit = '1';

  var dataEl = document.querySelector('[data-npwmp-data="' + sid + '"]');
  var DATA = {};
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function variants(key) { return (DATA.products[key] && DATA.products[key].variants) || []; }

  var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-size]'));
  var widthBtns = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-width]'));
  var fulfillRadios = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-fulfill]'));
  var initialBtn = root.querySelector('[data-npwmp-size].active') || sizeBtns[0];
  var initialWidthBtn = root.querySelector('[data-npwmp-width].active') || widthBtns[0];
  var checkedRadio = root.querySelector('[data-npwmp-fulfill]:checked');
  var state = {
    index: initialBtn ? parseInt(initialBtn.dataset.index, 10) : (DATA.defaultIndex || 0),
    widthIndex: initialWidthBtn ? parseInt(initialWidthBtn.dataset.windex, 10) : 0,
    fulfillment: checkedRadio ? checkedRadio.value : (DATA.defaultFulfillment || 'instock')
  };

  function activeWidthBtn() { return root.querySelector('[data-npwmp-width].active'); }
  function activeLengthBtn() { return root.querySelector('[data-npwmp-size].active'); }
  function currentWidthValue() { var b = activeWidthBtn(); return b ? b.getAttribute('data-wvalue') : null; }
  function currentLengthValue() { var b = activeLengthBtn(); return b ? b.getAttribute('data-lvalue') : null; }

  // Resolve the variant for the chosen width + length within a fulfillment product.
  // Falls back to length-index matching for single-option products.
  function variantFor(key) {
    var list = variants(key);
    var w = currentWidthValue(), l = currentLengthValue();
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (DATA.hasWidth) { if (v.w === w && v.l === l) return v; }
      else if (v.l === l) return v;
    }
    return list[state.index] || null;
  }
  function activeVariant() { return variantFor(state.fulfillment); }

  // Upgrade-swap: the swap product's variant at the same POSITION as the active
  // one (both products must list their sizes in the same order — the same
  // convention the pre-order / in-stock pairing already relies on).
  function swapVariantFor() {
    var list = variants(state.fulfillment);
    var v = activeVariant();
    var idx = list.indexOf(v);
    if (idx < 0) idx = state.index || 0;
    var sw = (DATA.swap && DATA.swap.variants) || [];
    return sw[idx] || null;
  }

  // Colour-matched variant of a side product (add-on shed / "buy separately" row):
  // the variant whose option values include the active colour (the width OR the
  // length value, whichever the colour picker is bound to), else the first available.
  function matchedVariant(list) {
    list = list || [];
    var w = currentWidthValue(), l = currentLengthValue();
    var hit = null;
    for (var i = 0; i < list.length && !hit; i++) {
      var o = list[i].opts || [];
      if ((w && o.indexOf(w) >= 0) || (l && o.indexOf(l) >= 0)) hit = list[i];
    }
    if (!hit) { for (var j = 0; j < list.length; j++) { if (list[j].available) { hit = list[j]; break; } } }
    return hit || list[0] || null;
  }
  function addonVariantFor() { return (DATA.swapMode === 'addon' && DATA.swap) ? matchedVariant(DATA.swap.variants) : null; }
  function altVariantFor() { return DATA.alt ? matchedVariant(DATA.alt.variants) : null; }

  // ---- standalone in-stock detection (price-based) ----
  // This template can be assigned to a product whose pre-order / in-stock mapping is
  // reversed — e.g. an in-stock-only product still linked to a pre-order counterpart.
  // When the product in the PRE-ORDER slot is priced strictly HIGHER than the one in
  // the IN-STOCK slot, this page is really a standalone in-stock product: collapse to
  // a single in-stock buy — hide the option selector and force the in-stock button +
  // shipping note, while still selling the page product. Equal prices (e.g. lean-to)
  // are deliberately ignored — only a strictly higher pre-order price triggers this.
  var PAGE_KEY = (DATA.pageRole === 'instock') ? 'instock' : 'preorder';
  var IS_SWAPPED = (function () {
    if (!(DATA.products.preorder && DATA.products.instock)) return false;
    var pv = variantFor('preorder'), iv = variantFor('instock');
    if (!pv || !iv) return false;
    return pv.price > iv.price;
  })();
  if (IS_SWAPPED) {
    state.fulfillment = PAGE_KEY;
    var swOpts = root.querySelector('[data-npwmp-fulfill-options]');
    var swLbl = root.querySelector('[data-npwmp-fulfill-label]');
    if (swOpts) swOpts.hidden = true;
    if (swLbl) swLbl.style.display = 'none';
  }

  // Roof-window count for the current length (from the product metafield), min 1.
  function windowCount() {
    var arr = DATA.windows || [];
    var n = parseInt(arr[state.index], 10);
    return (n && n > 0) ? n : 1;
  }

  // All prices on this PDP display whole dollars (no cents), per the store rule.
  function formatCents(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }
  var formatWhole = formatCents;

  function accQty(chk) {
    return (chk.hasAttribute('data-acc-window-qty') || chk.hasAttribute('data-acc-qty-sel')) ? (parseInt(chk.getAttribute('data-acc-qty'), 10) || 1) : 1;
  }

  // Sum of the prices (cents) of every checked accessory upsell (× its quantity).
  function accessoriesTotal() {
    var sum = 0;
    root.querySelectorAll('[data-npwmp-accessory]:checked').forEach(function (chk) {
      var p = parseInt(chk.getAttribute('data-acc-price'), 10);
      if (!isNaN(p)) sum += p * accQty(chk);
    });
    return sum;
  }

  // ---- Premium bundle card ----
  // One accessory (schema bundle_slot) is the all-in-one bundle. Its crossed-out
  // "was" price is the live sum of the OTHER add-ons (window opener × the roof
  // window count). Ticking it unchecks the others (remembering what the shopper
  // had picked) and locks them as "Included", so only the bundle product enters
  // the cart; unticking restores the shopper's own selections.
  var bundleChk = root.querySelector('[data-acc-bundle]');
  function bundleOthers() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-accessory]')).filter(function (c) { return c !== bundleChk && !c.hasAttribute('data-acc-standalone'); });
  }
  function updateBundle() {
    if (!bundleChk) return;
    // Size-dependent bundle product: while the selected size has a single roof
    // window the bundle swaps to its 1-opener counterpart (schema
    // bundle_small_product). Name and tooltip stay put; only the cart variant,
    // the price pill and the struck "was" sum change with the size.
    var smallV = bundleChk.getAttribute('data-acc-small-variant');
    if (smallV) {
      if (!bundleChk.hasAttribute('data-acc-main-variant')) {
        bundleChk.setAttribute('data-acc-main-variant', bundleChk.value);
        bundleChk.setAttribute('data-acc-main-price', bundleChk.getAttribute('data-acc-price') || '0');
      }
      var isSmall = windowCount() <= 1;
      bundleChk.value = isSmall ? smallV : bundleChk.getAttribute('data-acc-main-variant');
      bundleChk.setAttribute('data-acc-price', isSmall ? (bundleChk.getAttribute('data-acc-small-price') || '0') : bundleChk.getAttribute('data-acc-main-price'));
      var bpEl = root.querySelector('[data-npwmp-bundle-price]');
      if (bpEl) bpEl.textContent = '+' + formatCents(parseInt(bundleChk.getAttribute('data-acc-price'), 10) || 0);
    }
    var others = bundleOthers();
    var wasEl = root.querySelector('[data-npwmp-bundle-was]');
    if (wasEl) {
      var was = 0;
      others.forEach(function (c) {
        var p = parseInt(c.getAttribute('data-acc-price'), 10) || 0;
        was += p * (c.hasAttribute('data-acc-window-qty') ? windowCount() : 1);
      });
      var price = parseInt(bundleChk.getAttribute('data-acc-price'), 10) || 0;
      if (was > price) { wasEl.textContent = formatCents(was); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    var on = bundleChk.checked;
    // The upgrade-swap card is NOT part of the bundle; while the bundle is on,
    // this class reveals its "not included" note (CSS .ua-swap-note).
    var accWrap = bundleChk.closest('.upsell-acc');
    if (accWrap) accWrap.classList.toggle('ua-bundle-on', on);
    others.forEach(function (c) {
      var card = c.closest('.ua-card');
      if (!card) return;
      if (on) {
        if (!card.classList.contains('is-bundled')) {
          c.setAttribute('data-bundle-prev', c.checked ? '1' : '0');
          c.setAttribute('data-bundle-prev-qty', c.getAttribute('data-acc-qty') || '');
          c.checked = false;
          card.classList.add('is-bundled');
        }
        // Opener always displays the full roof-window count while bundled
        // (re-applied every render so size switches keep it in sync).
        if (c.hasAttribute('data-acc-window-qty')) c.setAttribute('data-acc-qty', windowCount());
      } else if (card.classList.contains('is-bundled')) {
        c.checked = c.getAttribute('data-bundle-prev') === '1';
        var pq = c.getAttribute('data-bundle-prev-qty');
        if (pq) c.setAttribute('data-acc-qty', pq);
        card.classList.remove('is-bundled');
      }
    });
  }

  // Quantity-scaled accessories (the window opener): clamp the qty to the roof-window
  // count, refresh the "up to N" label, the stepper bounds and the +$ price.
  // Generic quantity-enabled accessories (schema toggle): no window clamp, capped at 99.
  function updateQtySelectors() {
    root.querySelectorAll('[data-acc-qty-sel]').forEach(function (chk) {
      var card = chk.closest('.ua-card');
      if (!card) return;
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      var qtyEl = card.querySelector('[data-npwmp-opener-qty]');
      var priceEl = card.querySelector('[data-npwmp-opener-price]');
      var minusEl = card.querySelector('.ua-minus');
      var plusEl = card.querySelector('.ua-plus');
      if (qtyEl) qtyEl.textContent = qty;
      var unit = parseInt(chk.getAttribute('data-acc-price'), 10) || 0;
      if (priceEl && unit > 0) priceEl.textContent = '+' + formatCents(unit * qty);
      if (minusEl) minusEl.disabled = qty <= 1;
      if (plusEl) plusEl.disabled = qty >= 99;
    });
  }

  function updateOpeners() {
    var max = windowCount();
    root.querySelectorAll('[data-acc-window-qty]').forEach(function (chk) {
      var card = chk.closest('.ua-card');
      if (!card) return;
      // Only offer the quantity stepper when more than one window is available.
      card.classList.toggle('ua-no-qty', max <= 1);
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      if (qty > max) qty = max;
      if (qty < 1) qty = 1;
      chk.setAttribute('data-acc-qty', qty);
      var qtyEl = card.querySelector('[data-npwmp-opener-qty]');
      var maxEl = card.querySelector('[data-npwmp-opener-max]');
      var priceEl = card.querySelector('[data-npwmp-opener-price]');
      var minusEl = card.querySelector('.ua-minus');
      var plusEl = card.querySelector('.ua-plus');
      if (qtyEl) qtyEl.textContent = qty;
      if (maxEl) maxEl.textContent = max;
      // Bundle tooltip gallery: keep the openers' x-count badge on the live window count.
      root.querySelectorAll('[data-ig-bi-qty]').forEach(function (b) { b.textContent = '×' + max; });
      var unit = parseInt(chk.getAttribute('data-acc-price'), 10) || 0;
      if (priceEl && unit > 0) priceEl.textContent = '+' + formatCents(unit * qty);
      if (minusEl) minusEl.disabled = qty <= 1;
      if (plusEl) plusEl.disabled = qty >= max;
    });
  }

  // "N roof window(s)" copy in the width-note.
  function updateWindowsNote() {
    var n = windowCount();
    var word = n === 1 ? ' roof window' : ' roof windows';
    root.querySelectorAll('[data-npwmp-windows]').forEach(function (el) { el.textContent = n + word; });
  }

  // Variant-picker dimension note: swap the line to the active option's note (each
  // option button carries its own note in data-npwmp-dimnote). No-op for the colour
  // selector, which has a single static note and no output element.
  function updateDimNote() {
    var out = root.querySelector('[data-npwmp-dimnote-out]');
    if (!out) return;
    var b = root.querySelector('[data-npwmp-size].active');
    if (b && b.hasAttribute('data-npwmp-dimnote')) out.innerHTML = b.getAttribute('data-npwmp-dimnote');
  }

  // Disable length boxes with no available variant for the current width.
  function updateLengthAvailability() {
    if (!DATA.hasWidth) return;
    var list = variants(state.fulfillment);
    var w = currentWidthValue();
    sizeBtns.forEach(function (btn) {
      var l = btn.getAttribute('data-lvalue');
      var match = null;
      for (var i = 0; i < list.length; i++) { if (list[i].w === w && list[i].l === l) { match = list[i]; break; } }
      btn.disabled = !!(match && !match.available);
    });
  }

  function render() {
    updateLengthAvailability();
    updateWindowsNote();
    updateDimNote();
    // Add-on shed card: keep its cart variant + price on the selected colour.
    var addonChk = root.querySelector('[data-npwmp-addon]');
    if (addonChk) {
      var av = addonVariantFor();
      if (av) { addonChk.value = av.id; addonChk.setAttribute('data-acc-price', av.price); }
      var apEl = root.querySelector('[data-npwmp-addon-price]');
      if (apEl && av) apEl.textContent = '+' + formatCents(av.price);
      var aDead = !av || !av.available;
      addonChk.disabled = aDead; if (aDead) addonChk.checked = false;
      var aCard = addonChk.closest('.ua-card'); if (aCard) aCard.classList.toggle('ua-card--disabled', aDead);
    }
    var altPriceEl = root.querySelector('[data-npwmp-alt-price]');
    if (altPriceEl) { var altV = altVariantFor(); if (altV) altPriceEl.textContent = formatCents(altV.price); }
    updateBundle();
    updateOpeners();
    updateQtySelectors();
    var v = activeVariant();
    var addOn = accessoriesTotal();

    // Upgrade-swap card: the price pill always shows the live difference to the
    // swap product's matching variant; while ticked, that variant becomes the
    // one being priced and purchased (the base product never enters the cart).
    var swapChk = root.querySelector('[data-npwmp-prodswap]');
    var swTarget = swapChk ? swapVariantFor() : null;
    if (swapChk) {
      var swPriceEl = root.querySelector('[data-npwmp-swap-price]');
      var swDiff = (swTarget && v) ? swTarget.price - v.price : 0;
      if (swPriceEl) swPriceEl.textContent = swDiff > 0 ? '+' + formatCents(swDiff) : '';
      var swDead = !swTarget || !swTarget.available;
      swapChk.disabled = swDead;
      if (swDead) swapChk.checked = false;
      var swCard = swapChk.closest('.ua-card');
      if (swCard) swCard.classList.toggle('ua-card--disabled', swDead);
    }
    var eff = (swapChk && swapChk.checked && swTarget) ? swTarget : v;

    var nowEl = root.querySelector('[data-npwmp-price-now]');
    var oldEl = root.querySelector('[data-npwmp-price-old]');
    var saveEl = root.querySelector('[data-npwmp-save]');
    var nowCents = eff ? eff.price + addOn : 0;
    if (nowEl) nowEl.textContent = eff ? formatCents(nowCents) : '';
    if (oldEl) oldEl.textContent = eff && eff.compare > eff.price ? formatCents(eff.compare + addOn) : '';
    if (saveEl) {
      if (eff && eff.compare > eff.price) { saveEl.style.display = ''; saveEl.textContent = 'Save ' + formatWhole(eff.compare - eff.price); }
      else { saveEl.style.display = 'none'; }
    }


    ['instock', 'preorder'].forEach(function (key) {
      var fv = variantFor(key);
      var fNow = root.querySelector('[data-npwmp-fo-now="' + key + '"]');
      var fOld = root.querySelector('[data-npwmp-fo-old="' + key + '"]');
      if (fNow) fNow.textContent = fv ? formatCents(fv.price + addOn) : '';
      if (fOld) fOld.textContent = fv && fv.compare > fv.price ? formatCents(fv.compare + addOn) : '';
    });

    var widthLbl = root.querySelector('[data-npwmp-width-value]');
    if (widthLbl) { var wb = activeWidthBtn(); var wv = wb && (wb.querySelector('.size-val') || wb.querySelector('.color-name')); widthLbl.textContent = wv ? wv.textContent : (wb ? wb.getAttribute('data-wvalue') || '' : ''); }

    var lblEl = root.querySelector('[data-npwmp-length-value]');
    if (lblEl) {
      var activeBtn = activeLengthBtn();
      var valEl = activeBtn && activeBtn.querySelector('.size-val');
      lblEl.textContent = valEl ? valEl.textContent : (v ? v.l : '');
    }

    var labelEl = root.querySelector('[data-npwmp-cta-label]');
    var noteEl = root.querySelector('[data-npwmp-cta-note]');
    var input = root.querySelector('[data-npwmp-variant-input]');
    var cta = root.querySelector('[data-npwmp-cta]');
    var framingKey = IS_SWAPPED ? 'instock' : state.fulfillment;
    if (labelEl) labelEl.textContent = (DATA.ctaLabels && DATA.ctaLabels[framingKey]) || 'Add to cart';
    if (noteEl) noteEl.innerHTML = (DATA.notes && DATA.notes[framingKey]) || '';
    if (input) input.value = eff ? eff.id : '';
    if (cta) {
      var ok = eff && eff.available;
      cta.disabled = !ok;
      if (!ok && labelEl) labelEl.textContent = eff ? 'Sold out' : 'Unavailable';
    }
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      sizeBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active'); btn.setAttribute('aria-pressed', 'true');
      state.index = parseInt(btn.dataset.index, 10);
      render();
    });
  });

  widthBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      widthBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active'); btn.setAttribute('aria-pressed', 'true');
      state.widthIndex = parseInt(btn.dataset.windex, 10);
      render();
    });
  });

  fulfillRadios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) { state.fulfillment = r.value; render(); } });
  });

  // ---- accessory upsells: live-update prices when toggled ----
  root.querySelectorAll('[data-npwmp-accessory]').forEach(function (chk) {
    chk.addEventListener('change', render);
  });
  root.querySelectorAll('[data-npwmp-prodswap]').forEach(function (chk) {
    chk.addEventListener('change', render);
  });

  // ---- window-opener quantity steppers (don't toggle the card's checkbox) ----
  root.querySelectorAll('[data-npwmp-opener-step]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var card = btn.closest('.ua-card');
      var chk = card && card.querySelector('[data-acc-window-qty], [data-acc-qty-sel]');
      if (!chk) return;
      var max = chk.hasAttribute('data-acc-window-qty') ? windowCount() : 99;
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      qty = Math.min(max, Math.max(1, qty + (parseInt(btn.getAttribute('data-npwmp-opener-step'), 10) || 0)));
      chk.setAttribute('data-acc-qty', qty);
      render();
    });
  });

  // ---- accessory info tooltips (tap-safe: don't toggle the Add checkbox) ----
  var infoBtns = Array.prototype.slice.call(root.querySelectorAll('.ua-info'));
  var tipHoverable = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  // Express badge tooltip: the bubble hangs from the badge's left edge, so on
  // narrow screens it can run past the right side of the viewport. Measure on
  // open and shift it left just enough to fit (12px gutter), keeping the arrow
  // over the (i) icon.
  function clampExpressTip(info) {
    var isExpress = info.classList.contains('express-info');
    // Accessory tips are centered on their (i) dot; a dot near the card edge
    // pushes the bubble out of the viewport on phones, so clamp those too -
    // but only on phones, desktop accessory tips are fine as-is.
    if (!isExpress && !(window.matchMedia && window.matchMedia('(max-width: 768px)').matches)) return;
    var tip = info.querySelector('.ua-tip');
    if (!tip) return;
    tip.style.marginLeft = '';
    tip.style.setProperty('--tip-arrow-x', '');
    var vw = document.documentElement.clientWidth;
    if (isExpress) {
      var tipW = Math.min(tip.offsetWidth || 264, vw - 24);
      var badge = info.closest('.express-tag') || info;
      var br = badge.getBoundingClientRect();
      var ir = info.getBoundingClientRect();
      var left = br.left;
      var overflow = left + tipW - (vw - 12);
      if (overflow > 0) left -= overflow;
      if (left < 12) left = 12;
      tip.style.marginLeft = (left - br.left) + 'px';
      var arrowX = (ir.left + ir.width / 2) - left;
      tip.style.setProperty('--tip-arrow-x', Math.max(14, Math.min(tipW - 14, arrowX)) + 'px');
      return;
    }
    // Centered bubble: shift it just enough to stay inside a 12px gutter and
    // point the arrow back at the dot (the ::after reads --tip-arrow-x).
    var tr = tip.getBoundingClientRect();
    if (!tr.width) return;
    var dr = info.getBoundingClientRect();
    var shift = 0;
    if (tr.left < 12) shift = 12 - tr.left;
    else if (tr.right > vw - 12) shift = (vw - 12) - tr.right;
    if (shift) tip.style.marginLeft = shift + 'px';
    var ax = (dr.left + dr.width / 2) - (tr.left + shift);
    tip.style.setProperty('--tip-arrow-x', Math.max(14, Math.min(tr.width - 14, ax)) + 'px');
  }
  root.querySelectorAll('.express-info').forEach(function (info) {
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      info.addEventListener(ev, function () { clampExpressTip(info); }, { passive: true });
    });
  });
  window.addEventListener('resize', function () {
    root.querySelectorAll('.ua-info.open, .ua-info.hover-open').forEach(clampExpressTip);
  });
  infoBtns.forEach(function (info) {
    info.addEventListener('click', function (e) {
      // A link inside the tooltip (e.g. the swap card's Read more) must navigate:
      // stop the label from toggling the checkbox, but keep the default.
      if (e.target.closest && e.target.closest('[data-npwmp-buy-alone]')) { e.preventDefault(); e.stopPropagation(); return; }
      if (e.target.closest && e.target.closest('.ua-tip__link')) { e.stopPropagation(); return; }
      e.preventDefault(); e.stopPropagation();
      var isOpen = info.classList.contains('open');
      infoBtns.forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) {
        info.classList.remove('is-suppressed');
        info.classList.add('open');
        clampExpressTip(info);
      } else {
        // Second click closes for real: drop focus and suppress the hover
        // reveal until the pointer leaves, or :hover / :focus-within would
        // keep the tip visible after .open is removed.
        if (info.blur) info.blur();
        info.classList.add('is-suppressed');
      }
    });
    info.addEventListener('mouseleave', function () { info.classList.remove('is-suppressed'); });
    // Desktop: :hover alone drops the tip the instant the pointer crosses the
    // gap between the (i) icon and the bubble, so the See more link was
    // unreachable except straight up. hover-open holds the tip through a short
    // grace window; reaching the bubble re-enters .ua-info (the bubble is its
    // DOM child), which fires mouseenter again and cancels the pending close.
    if (tipHoverable) {
      var graceT = null;
      info.addEventListener('mouseenter', function () {
        if (graceT) { clearTimeout(graceT); graceT = null; }
        if (!info.classList.contains('is-suppressed')) info.classList.add('hover-open');
      });
      info.addEventListener('mouseleave', function () {
        if (graceT) clearTimeout(graceT);
        graceT = setTimeout(function () { info.classList.remove('hover-open'); graceT = null; }, 350);
      });
    }
  });
  if (infoBtns.length) {
    // Capture phase: on touch devices a tap outside an open tooltip must ONLY
    // dismiss it - swallow the event so the same tap can't also hit a variant
    // selector or checkbox underneath. Desktop keeps click-through.
    document.addEventListener('click', function (e) {
      var anyOpen = false;
      infoBtns.forEach(function (i) { if (i.classList.contains('open')) anyOpen = true; });
      if (!anyOpen) return;
      if (e.target.closest && e.target.closest('.ua-info')) return;
      infoBtns.forEach(function (i) { i.classList.remove('open'); });
      if (!tipHoverable) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') infoBtns.forEach(function (i) { i.classList.remove('open'); }); });
  }

  // ---- Intelligems upsell-test events: tooltip views + Add ticks ----
  // Every tooltip in the accessories block (data-ig-tip) fires upsellTipView_<key>
  // when it is revealed (hover on desktop, tap-open on touch; throttled so hover
  // jitter doesn't double-count). Every Add tick (data-ig-add, checked only)
  // fires upsellAdd_<key>. Keys: acc1..acc8, bundle, swap. Pushed to igEvents
  // (Intelligems custom events) and dataLayer.
  function igUpsellEvent(name) {
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: name });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name });
    } catch (e) {}
  }
  root.querySelectorAll('.upsell-acc .ua-info[data-ig-tip]').forEach(function (info) {
    var key = info.getAttribute('data-ig-tip');
    var last = 0;
    function seen() {
      var now = Date.now();
      if (now - last < 800) return;
      last = now;
      igUpsellEvent('upsellTipView_' + key);
    }
    if (tipHoverable) info.addEventListener('mouseenter', seen);
    info.addEventListener('focusin', seen);
    info.addEventListener('click', function () {
      if (info.classList.contains('open')) seen();
    });
  });
  root.querySelectorAll('.upsell-acc .ua-check[data-ig-add]').forEach(function (chk) {
    chk.addEventListener('change', function () {
      if (chk.checked) igUpsellEvent('upsellAdd_' + chk.getAttribute('data-ig-add'));
    });
  });
  // Preview hook for the tooltip test variant without Intelligems:
  // ?ua-bundle-tip=1 shows the What's-inside gallery (same pattern as ?ygh-variant=b).
  if (/[?&]ua-bundle-tip=1/.test(window.location.search)) {
    var sec = root.querySelector('.npwmp-hero-section') || root;
    sec.classList.add('ua-tip-preview');
  }

  // ---- accessories "show more" / "show less" toggle ----
  root.querySelectorAll('[data-npwmp-acc-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.upsell-acc');
      if (!wrap) return;
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = btn.querySelector('[data-npwmp-acc-more-label]');
      if (label) label.textContent = expanded ? 'Show less' : 'Show more';
    });
  });

  // ---- gallery + lightbox (images + native video) ----
  (function () {
    var stage = root.querySelector('[data-npwmp-stage]');
    var mediaEl = root.querySelector('[data-npwmp-media="' + sid + '"]');
    if (!stage || !mediaEl) return;
    // Out-of-stock: blur + SOLD OUT stamp apply to the first image only. Liquid renders
    // .is-oos-first for MEDIA[0]; toggle it off/on as the shopper navigates the gallery.
    var galleryMain = root.querySelector('.gallery-main');
    var OOS = galleryMain && galleryMain.classList.contains('is-oos');
    var MEDIA = [];
    try { MEDIA = JSON.parse(mediaEl.textContent); } catch (e) { MEDIA = []; }
    if (!MEDIA.length) return;

    var total = MEDIA.length;
    var idx = 0;
    var stageSwiped = false; // set true by a mobile swipe so the tap-to-open handler is skipped
    var userPaused = false;  // true only after the shopper taps the corner pause control
    var vToggle = null;      // lower-right play/pause button, created once below

    // ---- image preloading for snappy gallery + lightbox navigation ----
    // The inline gallery shows the smaller "main" image; the lightbox shows the
    // 1600px "full" image. Preloading the relevant resolution ahead of time means
    // next/prev (and thumbnail jumps) are served from cache, not a cold fetch.
    var preloaded = { main: {}, full: {} };
    function preload(i, res) {
      if (total < 2) return;
      i = (i + total) % total;
      var bag = preloaded[res];
      if (bag[i]) return;
      var it = MEDIA[i];
      if (!it || it.type !== 'image') return;
      var url = res === 'full' ? it.full : (it.main || it.full);
      if (!url) return;
      var im = new Image();
      im.decoding = 'async';
      im.src = url;
      bag[i] = im;
    }
    function preloadNeighbors(res) { preload(idx + 1, res); preload(idx - 1, res); }
    // Background-prefetch every remaining image of the given resolution, radiating
    // out from the current one, at idle priority so it never competes with the active view.
    function preloadAllIdle(res) {
      var order = [], i;
      for (i = 1; i < total; i++) { order.push(idx + i); order.push(idx - i); }
      function run() { if (order.length) { preload(order.shift(), res); schedule(); } }
      function schedule() {
        if (window.requestIdleCallback) { requestIdleCallback(run, { timeout: 600 }); }
        else { setTimeout(run, 80); }
      }
      schedule();
    }

    var prev = root.querySelector('.gallery-prev');
    var next = root.querySelector('.gallery-next');
    var count = root.querySelector('.gallery-count');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-thumb]'));
    var vbadge = root.querySelector('[data-npwmp-vbadge]'); // corner "watch video" circle — first slide only

    // lightbox refs
    var lb       = root.querySelector('[data-npwmp-lightbox]');
    var lbMain   = root.querySelector('[data-npwmp-lightbox-main]');
    var lbStage  = root.querySelector('[data-npwmp-lightbox-stage]');
    var lbCount  = root.querySelector('[data-npwmp-lightbox-count]');
    var lbClose  = root.querySelector('[data-npwmp-lightbox-close]');
    var lbPrev   = root.querySelector('[data-npwmp-lightbox-prev]');
    var lbNext   = root.querySelector('[data-npwmp-lightbox-next]');
    var lbThumbs = root.querySelector('[data-npwmp-lightbox-thumbs]');

    // Robustly start a muted video. play() is often called before the media has
    // buffered (we preload only metadata), and that promise rejects on several
    // engines — the old code swallowed it and never retried, which is why the
    // gallery video "sometimes" failed to autoplay. Retry when it can actually
    // start, and again if playback is still refused.
    function forcePlay(v) {
      if (!v) return;
      var attempt = function () {
        if (!v.isConnected) return;
        v.muted = true; // policy needs muted true at the moment of the call
        var p;
        try { p = v.play(); } catch (e) { return; }
        if (p && p.catch) p.catch(function () {});
      };
      attempt();
      v.addEventListener('loadeddata', attempt, { once: true });
      v.addEventListener('canplay', attempt, { once: true });
    }

    // Build an <img> or autoplay-ready <video> for a media item.
    function makeMedia(item, opts) {
      opts = opts || {};
      if (item.type === 'video' && item.src) {
        var v = document.createElement('video');
        if (opts.cls) v.className = opts.cls;
        v.src = item.src;
        if (item.full) v.poster = item.full;
        // Muted + inline is what unlocks autoplay under browser policy. Set them
        // as ATTRIBUTES (not just properties) and before play() is ever called —
        // iOS Safari only honours the attributes.
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.loop = true;
        // Inline gallery reads as a clean looping clip (no player chrome); the
        // fullscreen lightbox keeps controls so the shopper can pause / scrub.
        v.controls = (opts.cls === 'lightbox-img');
        v.preload = 'metadata';
        if (opts.autoplay) {
          v.autoplay = true;
          forcePlay(v);
        }
        return v;
      }
      var img = document.createElement('img');
      if (opts.cls) img.className = opts.cls;
      img.decoding = 'async';
      // Lightbox needs the full-res image; the inline gallery only needs the smaller "main".
      if (opts.cls === 'lightbox-img') { img.src = item.full; img.fetchPriority = 'high'; }
      else { img.src = item.main || item.full; }
      img.alt = item.alt || '';
      return img;
    }
    function stopVideos(container) {
      if (!container) return;
      container.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    }
    function renderStage(autoplay) {
      stopVideos(stage);
      var item = MEDIA[idx];
      var el = makeMedia(item, { cls: 'hero-main', autoplay: autoplay && item.type === 'video' });
      stage.innerHTML = '';
      stage.appendChild(el);
      if (item.type === 'video') {
        el.addEventListener('play', syncVideoUI);
        el.addEventListener('pause', syncVideoUI);
      }
      syncVideoUI();
    }

    // Reflect the current slide's video state on the corner control. The button
    // (and its bottom-right slot) exist only while a video slide is showing.
    function syncVideoUI() {
      var v = stage.querySelector('video');
      var isVideo = !!v;
      if (galleryMain) galleryMain.classList.toggle('is-video-active', isVideo);
      if (!vToggle || !isVideo) return;
      vToggle.classList.toggle('is-paused', v.paused);
      vToggle.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    function syncThumbs() {
      thumbs.forEach(function (t) { t.classList.toggle('active', parseInt(t.dataset.index, 10) === idx); });
    }

    // Keep the active thumb in view in the single-row strip (centred when possible).
    // Scrolls ONLY the strip itself: scrollIntoView({inline:'center'}) also scrolls
    // every scrollable ancestor, and on phones that dragged the whole page sideways
    // when a colour pick swapped the gallery image.
    function centerInStrip(strip, el) {
      if (!strip || !el || strip.scrollWidth <= strip.clientWidth + 1) return;
      var left = el.getBoundingClientRect().left - strip.getBoundingClientRect().left
        + strip.scrollLeft - (strip.clientWidth - el.offsetWidth) / 2;
      strip.scrollLeft = Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth));
    }
    function scrollThumbIntoView() {
      var t = thumbs[idx];
      if (t) centerInStrip(t.parentNode, t);
    }

    function show(i, autoplay) {
      idx = (i + total) % total;
      // Landing on a video slide is a fresh intent to autoplay, so clear any
      // earlier manual pause.
      if (MEDIA[idx] && MEDIA[idx].type === 'video') userPaused = false;
      renderStage(autoplay !== false);
      preloadNeighbors('main');
      syncThumbs();
      scrollThumbIntoView();
      if (prev) prev.classList.toggle('is-hidden', idx === 0);
      if (OOS) galleryMain.classList.toggle('is-oos-first', idx === 0);
      if (vbadge) vbadge.classList.toggle('is-slide-hidden', idx !== 0);
      if (count) count.textContent = (idx + 1) + ' / ' + total;
      if (lb && !lb.hidden) renderLightbox();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.index, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    // ---- inline video play/pause control (video slide only) ----
    // Autoplay is best-effort; if the browser blocked it (power-saving mode, a
    // pre-buffer rejection, etc.) the only prior way to start the clip was tapping
    // its thumbnail. This lower-right button gives an obvious control instead.
    if (galleryMain) {
      vToggle = document.createElement('button');
      vToggle.type = 'button';
      vToggle.className = 'gallery-vtoggle';
      vToggle.setAttribute('aria-label', 'Play video');
      vToggle.innerHTML =
        '<svg class="gv-ic gv-ic--play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
        '<svg class="gv-ic gv-ic--pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
      galleryMain.appendChild(vToggle);
      vToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = stage.querySelector('video');
        if (!v) return;
        if (v.paused) { userPaused = false; forcePlay(v); }
        else { userPaused = true; try { v.pause(); } catch (err) {} }
      });
    }

    // Some browsers refuse autoplay until the visitor interacts with the page at
    // all. On the first interaction anywhere, nudge the active inline video —
    // unless the shopper deliberately paused it.
    function nudgeInlineVideo() {
      if (userPaused) return;
      var v = stage.querySelector('video');
      if (v && v.paused) forcePlay(v);
    }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, nudgeInlineVideo, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) nudgeInlineVideo();
    });

    // ---- variant ↔ gallery sync ----
    // Each colour/model button carries the matching variant's featured-media id
    // (data-npwmp-media). Selecting a variant swaps the main gallery image to it.
    var mediaIndexById = {};
    MEDIA.forEach(function (m, i) { if (m.id != null) mediaIndexById[String(m.id)] = i; });
    function showByMediaId(id) {
      if (!id) return;
      var i = mediaIndexById[String(id)];
      if (i != null && i !== idx) show(i);
    }
    // Only on an actual variant pick — NOT on load. First load deliberately keeps
    // the main gallery image (MEDIA[0]) rather than the default variant's image.
    // Size buttons AND colour buttons bound to the product's other option (data-npwmp-width) swap the gallery.
    root.querySelectorAll('[data-npwmp-size], [data-npwmp-width]').forEach(function (b) {
      b.addEventListener('click', function () { showByMediaId(b.getAttribute('data-npwmp-variant-media')); });
    });

    // Main gallery: swipe left/right on mobile to change the image.
    // A registered swipe sets stageSwiped so the tap-to-open-lightbox handler is skipped.
    (function () {
      var gsX = 0, gsY = 0, gsActive = false, gsMoved = false;
      stage.addEventListener('touchstart', function (e) {
        if (!e.touches[0]) return;
        gsActive = true; gsMoved = false;
        gsX = e.touches[0].clientX; gsY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!gsActive || !e.touches[0]) return;
        var dx = e.touches[0].clientX - gsX, dy = e.touches[0].clientY - gsY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) gsMoved = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!gsActive) return;
        gsActive = false;
        var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : gsX;
        var dx = ex - gsX;
        if (gsMoved && Math.abs(dx) > 40) { stageSwiped = true; show(dx < 0 ? idx + 1 : idx - 1, false); }
      }, { passive: true });
    })();

    // ---- lightbox ----
    var resetLightboxZoom = null; // assigned by the zoom module below
    function renderLightbox() {
      if (!lbStage) return;
      if (resetLightboxZoom) resetLightboxZoom();
      stopVideos(lbStage);
      var item = MEDIA[idx];
      var el = makeMedia(item, { cls: 'lightbox-img', autoplay: item.type === 'video' });
      lbStage.innerHTML = '';
      lbStage.appendChild(el);
      preloadNeighbors('full');
      if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + total;
      var multi = total > 1;
      if (lbPrev) lbPrev.style.display = multi ? '' : 'none';
      if (lbNext) lbNext.style.display = multi ? '' : 'none';
      if (lbThumbs) {
        Array.prototype.forEach.call(lbThumbs.children, function (c) {
          var on = parseInt(c.dataset.index, 10) === idx;
          c.classList.toggle('active', on);
          if (on) centerInStrip(lbThumbs, c);
        });
      }
    }
    function openLightbox() {
      stopVideos(stage);
      renderLightbox();
      preloadAllIdle('full');
      lb.hidden = false;
      document.body.classList.add('drawer-lock');
    }
    function closeLightbox() {
      lb.hidden = true;
      if (resetLightboxZoom) resetLightboxZoom();
      stopVideos(lbStage);
      if (!document.querySelector('.acc-drawer.is-open')) document.body.classList.remove('drawer-lock');
      // resume the inline video if the active media is a video
      if (MEDIA[idx] && MEDIA[idx].type === 'video') renderStage(true);
    }

    // Build the lightbox thumbnail strip from the media list.
    if (lbThumbs) {
      MEDIA.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lightbox-thumb';
        b.dataset.index = i;
        var im = document.createElement('img');
        im.src = item.thumb; im.alt = item.alt || ''; im.loading = 'lazy';
        b.appendChild(im);
        if (item.type === 'video') {
          var pl = document.createElement('span');
          pl.className = 'thumb-play';
          pl.setAttribute('aria-hidden', 'true');
          pl.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
          b.appendChild(pl);
        }
        b.addEventListener('click', function () { show(i); });
        lbThumbs.appendChild(b);
      });
    }

    if (lb) {
      // Click the main image (not a video) to open the lightbox.
      stage.addEventListener('click', function (e) {
        if (stageSwiped) { stageSwiped = false; return; }
        if (e.target.closest('video')) return;
        openLightbox();
      });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      // Click the image to zoom into that point; move (desktop) or drag (touch)
      // to pan; click again to zoom out — matching the old gallery modal.
      if (lbStage) {
        var ZOOM = 2;
        var zoomedImg = null;
        var justSwiped = false;
        var clampPct = function (v) { return Math.max(0, Math.min(100, v)); };
        var setOrigin = function (img, ox, oy) { img.style.transformOrigin = clampPct(ox) + '% ' + clampPct(oy) + '%'; };
        var zoomOut = function (img) {
          if (!img) return;
          img.classList.remove('is-zoomed', 'is-panning');
          img.style.transform = '';
          img.style.transformOrigin = '';
          if (zoomedImg === img) zoomedImg = null;
        };
        resetLightboxZoom = function () { if (zoomedImg) zoomOut(zoomedImg); zoomedImg = null; };

        lbStage.addEventListener('click', function (e) {
          var img = e.target.closest && e.target.closest('img.lightbox-img');
          if (!img) return;
          e.stopPropagation();
          if (justSwiped) { justSwiped = false; return; }
          if (img.classList.contains('is-zoomed')) { zoomOut(img); return; }
          var rect = img.getBoundingClientRect();
          setOrigin(img, ((e.clientX - rect.left) / rect.width) * 100, ((e.clientY - rect.top) / rect.height) * 100);
          img.style.transform = 'scale(' + ZOOM + ')';
          img.classList.add('is-zoomed');
          zoomedImg = img;
        });
        // Desktop: hover moves the focal point across the zoomed image.
        lbStage.addEventListener('mousemove', function (e) {
          if (!zoomedImg) return;
          var rect = zoomedImg.getBoundingClientRect();
          setOrigin(zoomedImg, ((e.clientX - rect.left) / rect.width) * 100, ((e.clientY - rect.top) / rect.height) * 100);
        });
        // Touch: drag to pan.
        var tsx = 0, tsy = 0, ox0 = 50, oy0 = 50, panning = false;
        lbStage.addEventListener('touchstart', function (e) {
          if (!zoomedImg || !e.touches[0]) return;
          panning = false;
          tsx = e.touches[0].clientX; tsy = e.touches[0].clientY;
          var parts = (zoomedImg.style.transformOrigin || '50% 50%').split(' ');
          ox0 = parseFloat(parts[0]) || 50; oy0 = parseFloat(parts[1]) || 50;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function (e) {
          if (!zoomedImg || !e.touches[0]) return;
          var dx = e.touches[0].clientX - tsx, dy = e.touches[0].clientY - tsy;
          if (!panning) { if (Math.sqrt(dx * dx + dy * dy) > 10) { panning = true; zoomedImg.classList.add('is-panning'); } else return; }
          if (e.cancelable) e.preventDefault();
          var rect = zoomedImg.getBoundingClientRect();
          setOrigin(zoomedImg, ox0 - (dx / rect.width) * 100, oy0 - (dy / rect.height) * 100);
        }, { passive: false });
        lbStage.addEventListener('touchend', function () { if (zoomedImg) zoomedImg.classList.remove('is-panning'); panning = false; });

        // Swipe left/right to navigate when not zoomed.
        var swX = 0, swY = 0, swActive = false, swMoved = false;
        lbStage.addEventListener('touchstart', function (e) {
          justSwiped = false;
          if (zoomedImg || !e.touches[0]) { swActive = false; return; }
          swActive = true; swMoved = false;
          swX = e.touches[0].clientX; swY = e.touches[0].clientY;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function (e) {
          if (!swActive || zoomedImg || !e.touches[0]) return;
          var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) swMoved = true;
        }, { passive: true });
        lbStage.addEventListener('touchend', function (e) {
          if (!swActive || zoomedImg) return;
          swActive = false;
          var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : swX;
          var dx = ex - swX;
          if (swMoved && Math.abs(dx) > 40) { justSwiped = true; show(dx < 0 ? idx + 1 : idx - 1); }
        }, { passive: true });
      }
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target === lbMain || e.target === lbStage) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    // Initial paint: the server already rendered the first image, so only rebuild
    // the stage when the first item is a video. Otherwise just sync the chrome.
    if (MEDIA[0] && MEDIA[0].type === 'video') renderStage(true);
    syncThumbs();
    if (count) count.textContent = '1 / ' + total;
    if (prev) prev.classList.add('is-hidden');
    // Warm the inline gallery: neighbours now, the rest at idle, so clicking
    // next/prev is served from cache instead of a cold fetch.
    preloadNeighbors('main');
    preloadAllIdle('main');
  })();

  // ---- stars ----
  root.querySelectorAll('.stars').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-stars') || '5', 10);
    var star = '<svg viewBox="0 0 24 24" fill="#159d59"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>';
    el.innerHTML = star.repeat(n);
  });

  // ---- hero review mini-gallery: one slide visible, arrows step through ----
  (function () {
    var wrap = root.querySelector('[data-npwmp-rvb]');
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-rvb-slide]'));
    if (slides.length < 2) return;   // single review renders static, no arrows exist

    var i = 0;
    function show(next) {
      i = (next + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === i);
        if (n === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
    }
    var prev = wrap.querySelector('[data-rvb-prev]');
    var next = wrap.querySelector('[data-rvb-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    // Hidden slides sit in display:none, where a loading="lazy" image never comes near
    // the viewport and so is never fetched. The arrow then reveals an <img> that only
    // starts downloading on click, which is the delay. Warm them at idle instead, with
    // the same sizes and srcset so the browser caches the exact candidate the slide will
    // request. Page load itself stays lazy: nothing is fetched until the browser is free.
    function warmOthers() {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img || img.getAttribute('data-rvb-warm')) return;
        img.setAttribute('data-rvb-warm', '1');
        var pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;          // set before srcset so selection matches
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.src;
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warmOthers, { timeout: 4000 });
    else setTimeout(warmOthers, 1500);

    // Swipe left/right on touch, matching the gallery and drawers.
    var sx = 0, sy = 0, active = false, moved = false;
    wrap.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      active = true; moved = false;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchmove', function (e) {
      if (!active || !e.touches[0]) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (!active) return;
      active = false;
      var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : sx;
      var dx = ex - sx;
      if (moved && Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  })();

  // ---- drawers (same proven pattern as the standalone drawer section: one fixed
  //      full-screen host that IS the dim layer, panels slide in from the right,
  //      click the dim / X / Esc to close) ----
  (function () {
    // A single host holds every panel. It's the dim layer itself (its own
    // translucent background) and lives inside the section, at a very high
    // z-index so it sits above the page.
    var host = document.createElement('div');
    host.className = 'npwmp-hero-drawer-host';
    root.appendChild(host);

    var accItems = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-acc]'));
    var drawers = [];
    accItems.forEach(function (item) {
      var panel = item.querySelector('.acc-drawer');
      if (!panel) return;
      var target = item.getAttribute('data-link-target') || '';
      // The plan gallery travels with its drawer into the fixed host so it can be
      // positioned in the space beside it.
      var plans = item.querySelector('[data-npwmp-plans]');
      host.appendChild(panel);
      if (plans) host.appendChild(plans);
      drawers.push({ panel: panel, target: target, plans: plans, row: item.querySelector('.acc-row') });
    });
    if (!drawers.length) { host.remove(); return; }

    // Plan slides stay lazy so they cost nothing at page load, but lazy +
    // display:none means each arrow press used to fetch its image on demand.
    // Flipping them all to eager the moment their drawer opens fetches the
    // whole set in the background, so navigation is instant.
    function warmPlans(d) {
      if (!d.plans || d.plansWarm) return;
      d.plansWarm = true;
      d.plans.querySelectorAll('[data-npwmp-plan-slide]').forEach(function (im) { im.loading = 'eager'; });
    }
    function resetZoom(plansEl) {
      var st = plansEl.querySelector('.plan-gallery__stage.is-zoomed');
      if (st) { st.classList.remove('is-zoomed'); st.scrollLeft = 0; st.scrollTop = 0; }
    }

    function closeAll() {
      drawers.forEach(function (d) {
        d.panel.classList.remove('is-open'); d.panel.style.transform = '';
        if (d.plans) { d.plans.classList.remove('is-visible', 'is-fullscreen'); resetZoom(d.plans); }
      });
      host.classList.remove('is-open');
      document.body.classList.remove('drawer-lock');
    }
    function openDrawer(d) {
      if (!d) return;
      drawers.forEach(function (x) {
        if (x !== d) {
          x.panel.classList.remove('is-open');
          if (x.plans) x.plans.classList.remove('is-visible', 'is-fullscreen');
        }
      });
      if (d.plans) { d.plans.classList.add('is-visible'); warmPlans(d); }
      host.classList.add('is-open');
      document.body.classList.add('drawer-lock');
      // Next frame so the slide-in transition runs from the off-screen start.
      requestAnimationFrame(function () { d.panel.classList.add('is-open'); });
    }
    function openByTarget(t) {
      for (var i = 0; i < drawers.length; i++) { if (drawers[i].target === t) { openDrawer(drawers[i]); return; } }
    }

    drawers.forEach(function (d) {
      if (d.row) d.row.addEventListener('click', function () {
        d.panel.classList.contains('is-open') ? closeAll() : openDrawer(d);
      });
      var close = d.panel.querySelector('.drawer-close');
      if (close) close.addEventListener('click', closeAll);

      if (d.plans) {
        var slides = Array.prototype.slice.call(d.plans.querySelectorAll('[data-npwmp-plan-slide]'));
        var counter = d.plans.querySelector('[data-npwmp-plan-i]');
        var stage = d.plans.querySelector('.plan-gallery__stage');
        var at = 0;
        function showPlan(i) {
          if (!slides.length) return;
          resetZoom(d.plans);
          at = (i + slides.length) % slides.length;
          slides.forEach(function (im, n) { im.classList.toggle('is-active', n === at); });
          if (counter) counter.textContent = at + 1;
        }
        var prev = d.plans.querySelector('[data-npwmp-plan-prev]');
        var next = d.plans.querySelector('[data-npwmp-plan-next]');
        if (prev) prev.addEventListener('click', function () { showPlan(at - 1); });
        if (next) next.addEventListener('click', function () { showPlan(at + 1); });

        // Tap or click the plan to zoom to 2x, centred on the tap point; pan is
        // native scroll. Tapping again zooms back out.
        if (stage) stage.addEventListener('click', function (e) {
          var im = e.target.closest && e.target.closest('.plan-slide');
          if (!im) return;
          if (stage.classList.contains('is-zoomed')) { resetZoom(d.plans); return; }
          var r = im.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          stage.classList.add('is-zoomed');
          requestAnimationFrame(function () {
            stage.scrollLeft = fx * im.clientWidth - stage.clientWidth / 2;
            stage.scrollTop = fy * im.clientHeight - stage.clientHeight / 2;
          });
        });

        // Narrow screens have no room beside the drawer, so the gallery opens over it.
        var openBtn = d.panel.querySelector('[data-npwmp-plans-open]');
        if (openBtn) openBtn.addEventListener('click', function () { d.plans.classList.add('is-fullscreen'); });
        var closeBtn = d.plans.querySelector('[data-npwmp-plans-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { d.plans.classList.remove('is-fullscreen'); resetZoom(d.plans); });
      }

      // Swipe-right-to-close (mobile)
      var startX = 0, startY = 0, curX = 0, horizontal = false;
      d.panel.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = curX = e.touches[0].clientX; startY = e.touches[0].clientY; horizontal = false;
      }, { passive: true });
      d.panel.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        curX = e.touches[0].clientX;
        var dx = curX - startX, dy = e.touches[0].clientY - startY;
        if (!horizontal) {
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) { horizontal = true; d.panel.classList.add('dragging'); }
          else if (Math.abs(dy) > 10) { return; }
        }
        if (horizontal) d.panel.style.transform = 'translateX(' + Math.max(0, dx) + 'px)';
      }, { passive: true });
      d.panel.addEventListener('touchend', function () {
        if (!horizontal) return;
        d.panel.classList.remove('dragging');
        var dx = curX - startX;
        d.panel.style.transform = '';
        horizontal = false;
        if (dx > 90) closeAll();
      });
    });

    root.querySelectorAll('[data-npwmp-open]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); openByTarget(link.dataset.npwmpOpen); });
    });
    root.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('.ship-more');
      if (s) { e.preventDefault(); openByTarget('shipping'); }
    });

    // Click the dim (the host itself, anywhere outside the panel) or press Esc to close.
    host.addEventListener('click', function (e) { if (e.target === host) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && host.classList.contains('is-open')) closeAll(); });
  })();

  // ---- add to cart ----
  // Shared cart add: posts the items, refreshes and opens the mini cart. `btn` gets
  // the loading state; `primaryId` is reported to the cart-update publish.
  function addItems(items, btn, primaryId) {
    if (btn && btn.classList.contains('loading')) return;
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
    var miniCart = document.querySelector('mini-cart');
    var sections = miniCart && typeof miniCart.getSectionsToRender === 'function'
      ? miniCart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: items };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (r && r.status) { console.error('[npwmp] cart add error', r); return; }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'npwmp-hero', productVariantId: primaryId });
        }
        if (miniCart && typeof miniCart.renderContents === 'function') {
          try { miniCart.renderContents(r); } catch (err) { console.error(err); }
          setTimeout(function () { if (typeof miniCart.open === 'function') miniCart.open(); }, 100);
        } else {
          window.location = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        console.error('[npwmp] cart add failed', err);
      });
  }
  var form = root.querySelector('[data-npwmp-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('[data-npwmp-variant-input]');
      var cta = root.querySelector('[data-npwmp-cta]');
      if (!input || !input.value) return;
      var items = [{ id: input.value, quantity: 1 }];
      // For each checked accessory, add its pre-order counterpart variant when the
      // Pre-order option is selected (backend shipping profiles), otherwise the
      // visible in-stock variant. The shopper sees the same name/price either way.
      var usePreorder = !IS_SWAPPED && state.fulfillment === 'preorder';
      root.querySelectorAll('[data-npwmp-accessory]:checked').forEach(function (chk) {
        var preId = chk.getAttribute('data-acc-preorder-variant');
        var id = (usePreorder && preId) ? preId : chk.value;
        var qty = (chk.hasAttribute('data-acc-window-qty') || chk.hasAttribute('data-acc-qty-sel')) ? (parseInt(chk.getAttribute('data-acc-qty'), 10) || 1) : 1;
        if (id) items.push({ id: id, quantity: qty });
      });
      addItems(items, cta, input.value);
    });
  }
  // "Buy separately": only the side product (add-on shed from its tooltip, or the
  // row under the CTA) goes to the cart, colour-matched; the page product does not.
  root.querySelectorAll('[data-npwmp-buy-alone]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var v = btn.getAttribute('data-alt-key') === 'alt' ? altVariantFor() : addonVariantFor();
      if (!v || !v.available) return;
      igUpsellEvent('buyAlone_' + (btn.getAttribute('data-alt-key') || 'swap'));
      addItems([{ id: v.id, quantity: 1 }], btn, v.id);
    });
  });

  // ---- "Watch product video" triggers (corner badge + button under the gallery) -> sound-on pop-up ----
  (function () {
    var triggers = root.querySelectorAll('[data-npwmp-vopen]');
    var modal = root.querySelector('[data-npwmp-vmodal]');
    if (!triggers.length || !modal) return;
    var closeBtn = modal.querySelector('[data-npwmp-vmodal-close]');
    // Either native <video> elements or Wistia <wistia-player> elements (same slots, same
    // desktop/mobile CSS switch); both expose play()/pause()/currentTime/muted.
    var videos = Array.prototype.slice.call(modal.querySelectorAll('video, [data-npwmp-wplayer]'));
    var lastFocus = null;

    // With a separate desktop/mobile video, CSS shows exactly one; play the visible
    // one (offsetParent is null for the display:none copy). Falls back to the only video.
    function visibleVideo() {
      for (var i = 0; i < videos.length; i++) { if (videos[i].offsetParent !== null) return videos[i]; }
      return videos[0] || null;
    }
    function isWistia(v) { return v && v.tagName && v.tagName.toLowerCase() === 'wistia-player'; }
    function playEl(v) {
      if (!v) return;
      var go = function () {
        try { if (!isWistia(v)) v.currentTime = 0; } catch (e) {}
        try { v.muted = false; } catch (e) {}       // click is a user gesture, so audio is allowed
        try { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      };
      // A wistia-player that has not upgraded yet has no play(); wait for definition once.
      if (isWistia(v) && typeof v.play !== 'function' && window.customElements && customElements.whenDefined) {
        customElements.whenDefined('wistia-player').then(function () {
          go();
          // The player upgrades before its media is ready, and a play() issued in that
          // window is dropped. Re-issue it every 500 ms until playback starts (max 8 s);
          // stop as soon as the state leaves "beforeplay" (playing / paused by the user).
          var tries = 0, tick = setInterval(function () {
            var st = ''; try { st = v.state; } catch (e) {}
            tries++;
            if (st !== 'beforeplay' || tries > 16) { clearInterval(tick); return; }
            go();
          }, 500);
        }).catch(function () {});
      } else { go(); }
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      playEl(visibleVideo());
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      videos.forEach(function (v) { try { if (v.pause) v.pause(); } catch (e) {} });
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    triggers.forEach(function (t) { t.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  render();
}

  function boot(scope) {
    var blobs = (scope || document).querySelectorAll('[data-npwmp-data]');
    for (var i = 0; i < blobs.length; i++) init(blobs[i].getAttribute('data-npwmp-data'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
